import { render, staticRenderFns } from "./userCell.vue?vue&type=template&id=b436c23e"
import script from "./userCell.vue?vue&type=script&lang=js"
export * from "./userCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports